/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Faq_A3Inputs */

const en_pc_alt_faq_a3 = /** @type {(inputs: Pc_Alt_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. github.com/PDFCraftTool/pdfcraft is a browser-based PDF toolkit made by a different team. PdfCraft, covered on this site, is the desktop app at github.com/storytold/pdfcraft. They share only a similar name.`)
};

const zh_pc_alt_faq_a3 = /** @type {(inputs: Pc_Alt_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不是。github.com/PDFCraftTool/pdfcraft 是另一支团队开发的浏览器端 PDF 工具集。本站介绍的 PdfCraft 是位于 github.com/storytold/pdfcraft 的桌面应用。两者只是名称相近。`)
};

/**
* | output |
* | --- |
* | "No. github.com/PDFCraftTool/pdfcraft is a browser-based PDF toolkit made by a different team. PdfCraft, covered on this site, is the desktop app at github.co..." |
*
* @param {Pc_Alt_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_faq_a3 = /** @type {((inputs?: Pc_Alt_Faq_A3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Faq_A3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_faq_a3(inputs)
	return zh_pc_alt_faq_a3(inputs)
});
export { pc_alt_faq_a3 as "pc.alt.faq.a3" }